import React from 'react';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Status } from '@googlemaps/react-wrapper';

import { useFelaEnhanced } from 'hooks';
import { mapSelector } from 'modules/map/services/selectors';

import { EmptyWorkordersMap } from '../EmptyWorkordersMap';
import { WorkordersMapLoader } from '../WorkordersMapLoader';

import * as felaRules from './MapWrapper.rules';

export interface WorkordersMapWrapperProps {
    loading: boolean;
    empty: boolean;
    children: ReactNode;
}

export const MapWrapper = ({ loading, empty, children }: WorkordersMapWrapperProps) => {
    const { initializationStatus } = useSelector(mapSelector);

    const { styles } = useFelaEnhanced(felaRules);

    const showLoader = initializationStatus === Status.LOADING || loading;

    return (
        <div className={styles.container}>
            {initializationStatus === Status.SUCCESS ? children : null}

            {showLoader ? <WorkordersMapLoader /> : null}
            {!showLoader && empty ? <EmptyWorkordersMap /> : null}
        </div>
    );
};
